export default __webpack_public_path__ + "static/media/fourJokersSafe.8bc4d009.jpg";